import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const PopoverClassName = `${CLASS_NAME_PREFIX}-popover`;
export const PopoverTriggerClassName = `${PopoverClassName}__trigger`;
export const PopoverBodyClassName = `${PopoverClassName}__body`;
export const PopoverBodyHeaderClassName = `${PopoverBodyClassName}-header`;
export const PopoverBodyContentClassName = `${PopoverBodyClassName}-content`;
